import { getData } from "../index"

const defaultSate = {
	recipe: {}
}

export default function (state = defaultSate, action) {
	switch (action.type) {
		case "RECIPE_FOR_FLOW_LOADED":
			return {
				...state,
				recipe: action.recipe,
			}
		default:
			return {
				...state
			}
	}
}

//------------------------------------------------------------------//
//--------------------------- Selectors ----------------------------//
//------------------------------------------------------------------//

export function getPlanningRules(state, errorIfNotFound = false) {
	return getData(state, "misc.planningRules", errorIfNotFound && "No planning rules found")
}
